{
    "Accessibility Menu": "Menu de Acessibilidade",
    "Reset settings": "Redefinir configurações",
    "Close": "Fechar",
    "Content Adjustments": "Ajustes de Conteúdo",
    "Adjust Font Size": "Ajustar Tamanho da Fonte",
    "Highlight Title": "Destacar Título",
    "Highlight Links": "Destacar Links",
    "Readable Font": "Fonte Legível",
    "Color Adjustments": "Ajustes de Cor",
    "Dark Contrast": "Contraste Escuro",
    "Light Contrast": "Contraste Claro",
    "High Contrast": "Alto Contraste",
    "High Saturation": "Saturação Alta",
    "Low Saturation": "Saturação Baixa",
    "Monochrome": "Monocromático",
    "Tools": "Ferramentas",
    "Reading Guide": "Guia de Leitura",
    "Stop Animations": "Parar Animações",
    "Big Cursor": "Cursor Grande",
    "Increase Font Size": "Aumentar Tamanho da Fonte",
    "Decrease Font Size": "Diminuir Tamanho da Fonte",
    "Letter Spacing": "Espaçamento entre Letras",
    "Line Height": "Altura da Linha",
    "Font Weight": "Espessura da Fonte",
    "Dyslexia Font": "Fonte para Dislexia",
    "Language": "Idioma",
    "Open Accessibility Menu": "Abrir menu de acessibilidade"
}